module.exports = __webpack_public_path__ + "media/images/lp_modal-image_skill-81f818cc8add21b4337556956713e268.webp";